<template>
<div class="template_head">
    <div class="left">
      <svg-icon icon-class="template_brand" class="brand"></svg-icon>
      <div class="title">
        <span class="prefix">{{ prefixText }}</span>
        <span class="name">{{ creatorName }}</span>
        <span class="suffix">{{ suffixText }}</span>
      </div>
    </div>
    <div class="use" @click="gotoUse">
      <div class="title">{{ useText }}</div>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
export default {
  name: "TemplateInfoHead",
  props: {
    creatorName: {
      type: String
    },
    useTimes: {
      type: Number
    },
    templateId: {
      type: String
    },
    locale: {
      type: String,
      default: "zh-cn"
    },
    isWiki: {
      type: Boolean,
      default: false
    }
  },
  emits: ["gotoUseTemplate"],
  components: {},
  data() {
    return {};
  },
  computed: {
    prefixText() {
      if (this.locale === "en-us") {
        return "This template is created by ";
      }
      return intl.$t("该模板由#!!!#src/pages/H5/Cloud/components/TemplateInfoHead.vue_1");
    },
    suffixText() {
      if (this.useTimes > 0) {
        if (this.locale === "en-us") {
          return ` ,used by ${this.useTimes} people`;
        }
        return intl.$t(`创建，已被 {slot0} 人使用#!!!#src/pages/H5/Cloud/components/TemplateInfoHead.vue_1`, { slot0: this.useTimes });
      }
      if (this.locale === "en-us") {
        return " ,one-click use or share";
      }
      return intl.$t("创建，可一键使用或分享#!!!#src/pages/H5/Cloud/components/TemplateInfoHead.vue_1");
    },
    useText() {
      if (this.locale === "en-us") {
        return "Use this Template";
      }
      return intl.$t("使用该模板#!!!#src/pages/H5/Cloud/components/TemplateInfoHead.vue_1");
    }
  },
  methods: {
    gotoUse() {
      if (this.isWiki === true) {
        window.parent.postMessage(
          {
            type: "gotoUseTemplate",
            templateId: this.templateId
          },
          "*"
        );
      } else {
        this.$emit("gotoUseTemplate", this.templateId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.template_head {
  height: 48px;
  background-color: #edefff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .left {
    margin-left: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .brand {
      margin-right: 8px;
      width: 16px;
      height: 16px;
    }

    .title {
      .prefix {
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        line-height: 20px;
      }
      .name {
        font-weight: 400;
        font-size: 14px;
        color: #5c70ff;
        line-height: 20px;
      }
      .suffix {
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        line-height: 20px;
      }
    }
  }

  .use {
    margin-right: 16px;
    height: 30px;
    line-height: 28px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #5c70ff;
    border-radius: 6px;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #edefff;
    }

    .title {
      margin: 0px 10px;
      line-height: 20px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #5c70ff;
    }
  }
}
</style>
